import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-tool';

export default function Example() {
  return (
    <>
      <Head>
        <title>5 Poshmark Tools You Need - Rocket your Poshmark Sales</title>
        <meta
          name='description'
          content="If you're looking to boost your Poshmark sales, these five tools are an awesome place to start. We'll show you how the tools can boost your sales and help you maximize your profits."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-tools' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-tools' />
        <meta property='og:title' content='5 Poshmark Tools You Need - Rocket your Poshmark Sales' />
        <meta
          property='og:description'
          content="If you're looking to boost your Poshmark sales, these five tools are an awesome place to start. We'll show you how the tools can boost your sales and help you maximize your profits."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
